import { render, staticRenderFns } from "./badDebtEditTabInformation.vue?vue&type=template&id=018a726a&scoped=true&"
import script from "./badDebtEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./badDebtEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./badDebtEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018a726a",
  null
  
)

export default component.exports